import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/app/members/$memberId')({
  component: lazyRouteComponent(() => import('./-$memberId')),
})
